import React from 'react';
import { Input } from 'antd';
import { shape } from 'prop-types';

import Base from './Base';

const AntInput = props => {
  const { style } = props;
  return <Base {...props} component={Input} style={style} />;
};

AntInput.propTypes = {
  style: shape({}),
};

AntInput.defaultProps = {
  style: {},
};

export default AntInput;
